if($('.large-accordion').length) {

    $('.large-accordion .accordion-section').each(function() {

        let accordionItems = $(this).find('.accordion-items'),
            accordionItem = accordionItems.find('.accordion-item');

        accordionItem.on('click', function() {

            if($(this).hasClass('accordion-expanded')) {
                $(this).removeClass('accordion-expanded');
            } else {
                accordionItem.not($(this)).removeClass('accordion-expanded');
                $(this).addClass('accordion-expanded');
            }

        });

    });

}
